// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1cm8F","boxTitle":"Qualiphy_boxTitle__ejxwX","box":"Qualiphy_box__1WUuS","toggleWrap":"Qualiphy_toggleWrap__1gcSR"};